import { Component } from '@angular/core';
import { ThemeService } from './theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  // No need for NgClass
  template: `
    <button
      (click)="toggle()"
      class="flex items-center text-left p-2 text-sm rounded w-full transition-colors gap-2 bg-white text-gray-900 hover:bg-gray-100 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-900"
      aria-label="Toggle dark mode"
      title="Toggle dark mode"
    >
      @if (isDark()) { <span class="material-symbols-outlined align-middle text-lg mr-1">light_mode</span>
      Light } @else {
      <span class="material-symbols-outlined align-middle text-lg mr-1">dark_mode</span>
      Dark }
    </button>
  `,
})
export class ThemeToggleComponent {
  constructor(private theme: ThemeService) { }

  toggle() {
    this.theme.toggleTheme();
  }

  isDark() {
    return document.documentElement.classList.contains('dark');
  }
}
